import { createFileRoute } from "@tanstack/react-router";
import AdminLibrary from "@/pages/admin/AdminLibrary";

export const Route = createFileRoute("/_adminLayout/admin/library")({
  head: () => ({ meta: [
    { title: "RV Library & Data Coach | Rex & Sons RVs" },
    { name: "description", content: "Manage sourced RV model information and review unit repair previews in the Rex & Sons Library." },
    { property: "og:title", content: "RV Library & Data Coach | Rex & Sons RVs" },
    { property: "og:description", content: "Manage sourced RV model information and safely review linked unit repairs." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
  ] }),
  component: AdminLibrary,
});
